@if (showRegularTemplate()) {
    <ms-correct-score-option-group
        [event]="event()"
        [optionGroup]="optionGroup()"
        [isShowMoreDisabled]="isShowMoreDisabled()"
        [tracking]="tracking()"
        [trackingModuleType]="trackingModuleType()"
        [showMarketHelp]="showMarketHelp()"
        [crmPromotedOptionIdsMap]="crmPromotedOptionIdsMap()"
        [sourceOfPick]="sourceOfPick()"
        [betDetails]="betDetails()"
        [optionsLimitOverride]="optionsLimitOverride()" />
} @else {
    <ms-correct-score-option-group-compact
        [event]="event()"
        [optionGroup]="optionGroup()"
        [tracking]="tracking()"
        [trackingModuleType]="trackingModuleType()"
        [showMarketHelp]="showMarketHelp()"
        [crmPromotedOptionIdsMap]="crmPromotedOptionIdsMap()"
        [sourceOfPick]="sourceOfPick()"
        [betDetails]="betDetails()" />
}
